/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('regexService', regexService);

    function regexService(){
        var service = {
            alphanumeric: /^[A-Za-z0-9]+$/,
            alphabetic: /^[A-Za-z\s]+$/,
            email: /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
            password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/
        }

        return service;
    }
})();
